import { ecboClient } from 'lib/axios'

import type { ReservationQuoteParams } from 'features/space/types/reservation'

const API_RESERVATIONS_VALIDATE = '/api/web/reservations/validate'

/**
 * 予約内容のバリデーション (POST /api/web/reservations/validate)。
 * 失敗時の errors はキー -> メッセージ配列のマップ (legacy validateBookingReservation と同形)。
 */
export const validateReservation = async (params: ReservationQuoteParams, accessToken?: string) => {
  try {
    const response = await ecboClient.post<{ valid: boolean }>(API_RESERVATIONS_VALIDATE, params, {
      headers: accessToken ? { Authorization: `Token ${accessToken}` } : undefined,
    })

    return {
      valid: response.data.valid,
      errors: null,
    }
  } catch (error) {
    return {
      valid: false,
      errors: (error?.response?.data?.errors ?? null) as { [key: string]: string[] } | null,
    }
  }
}
